import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Gift } from "lucide-react";
import { WHATSAPP_LINK } from "../i18n";
import { firePixel } from "../lib/pixel";

export const ReturningVisitorPopup = ({ lang }) => {
  const [open, setOpen] = useState(false);
  const hi = lang === "hi";

  useEffect(() => {
    const visited = localStorage.getItem("cric1x_visited");
    const leadDone = localStorage.getItem("cric1x_lead_done");
    const shown = sessionStorage.getItem("cric1x_return_popup");
    if (!visited) {
      localStorage.setItem("cric1x_visited", "1");
      return;
    }
    if (leadDone || shown) return;
    const timer = setTimeout(() => {
      sessionStorage.setItem("cric1x_return_popup", "1");
      setOpen(true);
      firePixel("ViewContent", { content_name: "returning_visitor_popup" });
    }, 3500);
    return () => clearTimeout(timer);
  }, []);

  const claim = () => {
    firePixel("Lead", { content_name: "returning_visitor_claim" });
    window.open(WHATSAPP_LINK, "_blank");
    setOpen(false);
  };

  const goRegister = () => {
    setOpen(false);
    setTimeout(() => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" }), 250);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 px-5 backdrop-blur-sm"
          onClick={() => setOpen(false)}
          data-testid="returning-popup-overlay"
        >
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 30, scale: 0.97 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="relative w-full max-w-md border border-gold/40 bg-surface p-8 text-center"
            data-testid="returning-popup"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute right-4 top-4 text-white/40 transition-colors hover:text-white"
              data-testid="returning-popup-close"
            >
              <X size={20} />
            </button>
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold/10">
              <Gift className="text-gold" size={30} />
            </div>
            <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.3em] text-gold">
              {hi ? "वापसी पर स्वागत है" : "Welcome back"}
            </p>
            <h3 className="mt-3 font-display text-3xl font-bold uppercase leading-tight text-white">
              {hi ? "आपका बोनस अभी भी इंतज़ार में है!" : "Your bonus is still waiting!"}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60">
              {hi
                ? "पहली डिपॉज़िट पर 7% वेलकम बोनस + हर डिपॉज़िट पर 5% एक्स्ट्रा। अभी claim करो, offer limited है।"
                : "7% welcome bonus on your first deposit + 5% extra on every deposit. Claim now — limited time offer."}
            </p>
            <button
              onClick={claim}
              className="mt-6 w-full bg-gold py-4 font-display text-sm font-bold uppercase tracking-widest text-black transition-transform hover:scale-[0.99]"
              data-testid="returning-popup-claim-btn"
            >
              {hi ? "WhatsApp पर बोनस लो" : "Claim on WhatsApp"}
            </button>
            <button
              onClick={goRegister}
              className="mt-3 w-full border border-white/15 py-3.5 font-mono text-[11px] uppercase tracking-widest text-white/70 transition-colors hover:border-gold hover:text-gold"
              data-testid="returning-popup-register-btn"
            >
              {hi ? "या यहीं रजिस्टर करो" : "Or register here"}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
